import { CalendarSlotStatus } from "shared/constants";
export const getBookingBadgeStatus = (status: CalendarSlotStatus) => {
    let badgeStatus: string = "";
    //TO ASK: there a missing states, see calendar legend. + CLOSED is black, on figma is blue (as for busy)
    switch (status) {
        case CalendarSlotStatus.CONFIRMED:
            badgeStatus = "confirm";
            break;
        case CalendarSlotStatus.PENDING:
            badgeStatus = "warning";
            break;
        case CalendarSlotStatus.REJECTED:
            badgeStatus = "error";
            break;
        case CalendarSlotStatus.CLOSED:
            badgeStatus = "custom";
            break;
        case CalendarSlotStatus.CANCELLED:
            badgeStatus = "custom";
            break;
        case CalendarSlotStatus.SLOT_DELETED:
            badgeStatus = "custom";
            break;
        case CalendarSlotStatus.VACANT:
            badgeStatus = "custom";
            break;
        default:
            badgeStatus = "neutral";
            break;

    }
    return badgeStatus;
}